import React, {useContext, useEffect, useState} from "react";
import {OrganizationServiceContext} from "../../Contexts";
import Organization from "../../domain/Organization";
import QueryOptions from "../../sal-ui/QueryOptions";
import {FilterItem, FilterItemProps, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";

interface OrganizationItemProps extends FilterItemProps {
    organizations?: Organization[];
}

function OrganizationItem(props: OrganizationItemProps) {
    return (
        <SelectEditor
            width={180}
            multiple={true}
            showSearch={true}
            optionFilterProp="label"
            options={props.organizations?.map(organization => ({
                value: organization.id,
                label: organization.name
            }))}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

interface UserFilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    immediateMode?: boolean;
    persistentStateIdent?: string;
}

function UserFilter(props: UserFilterProps) {
    const organizationService = useContext(OrganizationServiceContext);
    const [organizations, setOrganizations] = useState<Organization[]>();

    useEffect(() => {
        organizationService.getList(QueryOptions.newUnlimitedOrderedInstance("name"))
            .then(result => setOrganizations(result.data));
    }, [organizationService]);

    const items: FilterItem[] = [
        {
            name: "organizationIds",
            key: "organizationIds",
            label: "Organization",
            render: props => <OrganizationItem {...props} organizations={organizations}/>
        }
    ];

    return (
        <SearchFilter
            items={items}
            className={props.className}
            values={props.values}
            defaultValues={{organizationIds: []}}
            persistentStateIdent={props.persistentStateIdent}
            defaultActiveFilterNames={["organizationIds"]}
            immediateMode={props.immediateMode}
            onChange={props.onChange}
        />
    );
}

export default UserFilter;
